import apiClient from './axios';

export interface WhitelistWallet {
  id: number;
  label: string;
  wallet_address: string;
  token: string;
  chain: string;
  is_compliant: boolean;
  dt_created: string;
  status?: 'pending' | 'compliant' | 'rejected'; // Derived from is_compliant
}

export interface CreateWhitelistWalletPayload {
  wallet_address: string;
  token: string;
  chain: string;
  is_compliant: boolean;
  label: string;
}

export interface CreateWhitelistWalletResponse {
  id: number;
  wallet_address: string;
  token: string;
  chain: string;
  is_compliant: boolean;
  dt_created: string;
  label: string;
}

export const getWhitelists = async (): Promise<WhitelistWallet[]> => {
  try {
    const response = await apiClient.get<WhitelistWallet[]>('/whitelists/');
    return response.data;
  } catch (error) {
    console.error('Error fetching whitelists:', error);
    throw error;
  }
};

export const createWhitelistWallet = async (
  payload: CreateWhitelistWalletPayload
): Promise<CreateWhitelistWalletResponse> => {
  try {
    const response = await apiClient.post<CreateWhitelistWalletResponse>(
      '/whitelists/',
      payload
    );
    return response.data;
  } catch (error) {
    console.error('Error creating whitelist wallet:', error);
    throw error;
  }
};

export const deleteWhitelistWallet = async (id: number): Promise<void> => {
  try {
    await apiClient.delete(`/whitelists/${id}/`);
  } catch (error) {
    console.error('Error deleting whitelist wallet:', error);
    throw error;
  }
};
